import { Box, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { convertCamelCaseToDisplayText } from "../../utils";
import moment from "moment";
export const HeaderConfig = [
  {
    label: "Name",
    id: "name",
  },
  {
    label: "Email",
    id: "email",
  },
  {
    label: "Role",
    id: "limits",
    render: (data) => {
      const result = data?.limits
        ? Object.keys(data?.limits)
            .filter((key) => data?.limits[key] === true)
            .map((key) => convertCamelCaseToDisplayText(key))
            .join(", ")
        : "-";

      return <Box sx={{ wordBreak: "break-all" }}>{result}</Box>;
    },
  },

  {
    label: "Created on",
    id: "createdAt",
    render: (data) => (
      <span>
        {data.createdAt && moment(data.createdAt).format("DD/MM/YYYY")}
      </span>
    ),
  },

  {
    label: "Action",
    id: "action",
    render: (data, onClick) => (
      <Box sx={{ display: "flex" }}>
        <IconButton onClick={() => onClick("EDIT", data)} sx={{ p: 0 }}>
          <EditIcon color="primary" />
        </IconButton>
        <IconButton onClick={() => onClick("DELETE", data)} sx={{ p: 0 }}>
          <DeleteIcon color="error" />
        </IconButton>
      </Box>
    ),
  },
];
export const getUserFormConfig = (editData) => {
  const list = [
    {
      name: "name",
      type: "text",
      label: "Name",
      placeholder: "Name",
      required: true,
    },
    {
      name: "email",
      type: "email",
      label: "Email",
      placeholder: "Email",
      required: true,
      validate: (value) =>
        !/\S+@\S+\.\S+/.test(value) ? "Email is invalid" : null,
    },
    {
      name: "password",
      type: "password",
      label: "Password",
      placeholder: "Password",
      validate: (value) =>
        value.length < 8 ? "Password should be atleast 8 digits" : null,
      required: editData?.id ? false : true,
    },
  ];
  return list;
};
